import { render, staticRenderFns } from "./HeadlineField.vue?vue&type=template&id=b1c788a4&scoped=true"
import script from "./HeadlineField.vue?vue&type=script&lang=js"
export * from "./HeadlineField.vue?vue&type=script&lang=js"
import style0 from "./HeadlineField.vue?vue&type=style&index=0&id=b1c788a4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c788a4",
  null
  
)

export default component.exports